import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCategoriesDataView } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import { ProductCollectionModel } from "@insite/client-framework/Types/ApiModels";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import Checkbox from "@insite/mobius/Checkbox";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
import LazyImage from "@insite/mobius/LazyImage";
import Link from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    openModalFlag: boolean;
    onCloseModal: () => void;
    product?: ProductCollectionModel;
    outdoorSafe: boolean;
    productName?: string;
}
interface RugPad {
    code: string;
    url: string;
    brandName: string;
}
const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    return {
        categoriesData: getCategoriesDataView(state, {}),
    };
};
type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface ModalStyle {
    headerContainer?: GridContainerProps;
    textGridItem?: GridItemProps;
    buttonGridItem?: GridItemProps;
    addButton?: ButtonPresentationProps;
    closeButton?: ButtonPresentationProps;
    mainContainer?: GridContainerProps;
    divComponent?: InjectableCss;
    rowContainer?: InjectableCss;
    brandText?: TypographyPresentationProps;
    typoContainer?: InjectableCss;
    modalContainer?: ModalPresentationProps;
    scrollableContent?: InjectableCss;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    footerWrapper?: InjectableCss;
    footerLink?: InjectableCss;
    headerWrapper?: InjectableCss;
}

export const rugStyleModal: ModalStyle = {
    headerContainer: {
        css: css`
            margin: 10px 0px;
            flex-wrap: wrap;
            display: flex;
            align-items: center;
        `,
    },
    textGridItem: {
        width: 12,
        css: css`
            padding: 10px;
            display: flex;
            align-items: center;
        `,
    },
    buttonGridItem: {
        width: 12,
        css: css`
            display: flex;
            justify-content: flex-end;
            padding: 10px;
            @media (min-width: 768px) {
                width: 6;
                height: 50px;
                padding: 0;
            }
        `,
    },
    addButton: {
        css: css`
            margin-right: 10px;
            span[class^="TypographyStyle"] {
                font-size: 14px;
            }
        `,
    },
    closeButton: {
        buttonType: "outline",
        css: css`
            span[class^="TypographyStyle"] {
                color: black;
                font-size: 14px;
            }
        `,
    },
    mainContainer: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            padding: 20px 20px 0 20px;
            width: 100%;
            box-sizing: border-box;

            @media (min-width: 768px) {
                justify-content: flex-start;
                padding: 20px 20px 0 20px;
            }
        `,
    },
    divComponent: {
        css: css`
            flex: 0 0 100%;
            margin: 10px;
            max-height: 420px;
            cursor: pointer;
            box-sizing: border-box;

            &.active {
                border: 3px solid #cac8c8;
                padding: 3px;
            }

            @media (min-width: 600px) {
                flex: 0 0 calc(50% - 20px);
            }

            @media (min-width: 992px) {
                flex: 0 0 calc(33.333% - 20px);
            }
        `,
    },
    rowContainer: {
        css: css`
            background: #f8f8f8;
            width: 100%;
            max-height: 350px;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;
        `,
    },

    brandText: {
        css: css`
            color: black;
            font-weight: 700 !important;
            text-align: left;
            margin-right: 4px;
            font-size: 14px;
        `,
    },

    typoContainer: {
        css: css`
            margin-top: 10px;
            text-align: left;
            padding: 0 8px;

            a,
            a:hover,
            a:focus {
                color: black;
                text-decoration: none;
            }
        `,
    },
    footerWrapper: {
        css: css`
            width: 100%;
            text-align: right;
            padding: 10px 20px;
            margin-top: 20px;
            margin-bottom: 10px;
        `,
    },
    footerLink: {
        css: css`
            text-decoration: underline !important;
            text-decoration-color: #866a5b !important;
            &:hover,
            &:focus {
                text-decoration: underline !important;
                text-decoration-color: #866a5b !important;
            }
        `,
    },
    modalContainer: {
        cssOverrides: {
            modalTitle: css`
                padding: 0 16px;
                background-color: #f8f8f8;
                border: 0px;
            `,
            modalBody: css`
                width: 95%;
                max-height: 85vh !important;
                overflow-y: auto;
                overflow-x: hidden;
                padding: 0;

                @media (min-width: 768px) {
                    width: 80%;
                    height: auto;
                }
                @media (min-width: 650px) {
                    width: 80%;
                    height: auto;
                }

                @media (min-width: 1200px) {
                    width: 70%;
                }
            `,
            titleButton: css`
                border-radius: 4px !important;
                padding: 0px !important;
                border: 1px solid black !important;
                min-height: 0px !important;

                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            position: absolute;
                            top: 8px;
                            right: 8px;
                        `,
                        css`
                            position: absolute;
                            top: 8px;
                            right: 8px;
                        `,
                        null,
                        null,
                        null,
                    ])}
            `,
        },
    },

    scrollableContent: {
        css: css`
            width: 100%;
        `,
    },
    centeringWrapper: {
        css: css`
            min-height: 150px;
            width: 100%;
            display: flex;
            align-items: center;
        `,
    },
    headerWrapper: {
        css: css`
            width: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                    `,
                    css`
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                    `,
                    css`
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                    `,
                ])}
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
};
const style = rugStyleModal;

const RugPadInfoDisplay = ({ openModalFlag, onCloseModal, outdoorSafe, productName }: Props) => {
    const [product, setProduct] = useState<RugPad[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [showCheckbox, setShowCheckbox] = useState(false);
    useEffect(() => {
        if (openModalFlag) {
            setIsLoading(true);
            const msg = siteMessage(outdoorSafe ? "OutdoorRugPad" : "RugPad");
            setProduct(JSON.parse(msg.toString()));
            setIsLoading(false);
        }
    }, [openModalFlag]);

    const modalCloseHandler = () => {
        if (showCheckbox) {
            localStorage.setItem("showPopup", "false");
        }
        onCloseModal();
    };

    const modalHeader = (
        <StyledWrapper {...style.headerWrapper}>
            <Hidden above="sm">
                <StyledWrapper
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        marginTop: "10px",
                    }}
                >
                    <Checkbox checked={showCheckbox} onChange={() => setShowCheckbox(!showCheckbox)} />
                    <Typography size={10}>{siteMessage("sessionCheckBox")}</Typography>
                </StyledWrapper>
            </Hidden>
            <StyledWrapper style={{ display: "flex", flexDirection: "column" }}>
                <Typography variant="h6" style={{ marginTop: "12px", marginBottom: "0px" }}>
                    {siteMessage("ModalRugTitle")}
                </Typography>
                <Typography style={{ fontSize: "11px", fontWeight: 400, fontStyle: "italic", marginBottom: "5px" }}>
                    {siteMessage("ModalSubTitle")}
                </Typography>
            </StyledWrapper>
            <Hidden below="md">
                <StyledWrapper
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        marginRight: "15px",
                    }}
                >
                    <Checkbox checked={showCheckbox} onChange={() => setShowCheckbox(!showCheckbox)} />
                    <Typography size={10}>{siteMessage("sessionCheckBox")}</Typography>
                </StyledWrapper>
            </Hidden>
        </StyledWrapper>
    );

    const mainModalBody = (
        <StyledWrapper {...style.scrollableContent}>
            {isLoading ? (
                <StyledWrapper {...style.centeringWrapper}>
                    <LoadingSpinner {...style.spinner} />
                </StyledWrapper>
            ) : (
                <>
                    <GridContainer {...style.mainContainer}>
                        {product?.map((p, index) => (
                            <StyledWrapper key={`item-${index}`} {...style.divComponent}>
                                <Link href={`/Catalog/Rugs/Rug-Pads/${p.code}?itemName=${productName}`}>
                                    <StyledWrapper {...style.rowContainer}>
                                        <LazyImage
                                            src={p.url}
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "contain",
                                                padding: "2px 16px",
                                            }}
                                        />
                                    </StyledWrapper>
                                    <StyledWrapper key={`typo-${index}`} {...style.typoContainer}>
                                        <Typography {...style.brandText}>{p.brandName} </Typography>
                                        <Typography style={{ fontSize: "14px", fontWeight: 400, color: "black" }}>
                                            {p.code}
                                        </Typography>
                                    </StyledWrapper>
                                </Link>
                            </StyledWrapper>
                        ))}
                    </GridContainer>
                    <StyledWrapper {...style.footerWrapper}>
                        <Link {...style.footerLink} href={`/Catalog/Rugs/Rug-Pads?itemName=${productName}`}>
                            <Typography>{siteMessage("rugModalFooter")}</Typography>
                        </Link>
                    </StyledWrapper>
                </>
            )}
        </StyledWrapper>
    );

    return (
        <>
            {openModalFlag && (
                <Modal
                    {...style.modalContainer}
                    sizeVariant="large"
                    handleClose={modalCloseHandler}
                    isOpen={openModalFlag}
                    headline={modalHeader}
                    isCloseable={true}
                >
                    {mainModalBody}
                </Modal>
            )}
        </>
    );
};

export default connect(mapStateToProps)(RugPadInfoDisplay);
